import { render } from "./TicketPurchase.vue?vue&type=template&id=60dcd247&scoped=true"
import script from "./TicketPurchase.vue?vue&type=script&lang=js"
export * from "./TicketPurchase.vue?vue&type=script&lang=js"

import "./TicketPurchase.vue?vue&type=style&index=0&id=60dcd247&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dcd247"]])

export default __exports__